import React from 'react';
import Select from 'react-select';
import SectionHeader from 'v2/common/DRM/SectionHeader/SectionHeader';
import { useFieldMutation } from 'v2/common/DRM/CustomTab/Field/hooks';
import { FieldTypeProps } from 'v2/common/DRM/CustomTab/Field/props';
import classNames from 'classnames';
import styles from '../../field.module.scss';

const DropdownField = ({
  fieldName,
  fieldLabel,
  value,
  entity,
  onUpdate,
  drmPage,
}: FieldTypeProps) => {
  const { mutate: updateFieldValue } = useFieldMutation({
    onUpdate,
    entity,
    drmPage,
    fieldName,
  });

  const handleOnChange = (option: { value: string } | null) => {
    if (!option || !entity.is_editable) return;
    updateFieldValue(option.value);
  };

  const acceptedValues =
    (entity.accepted_values as Record<string, string[]>)?.[fieldName].map(
      (value) => ({ label: value, value })
    ) || [];

  return (
    <>
      <SectionHeader
        title={fieldLabel}
        className={classNames(styles.sectionHeader)}
      />
      <Select
        data-cy={`tab-field-${fieldName}-dropdown`}
        onChange={handleOnChange}
        options={acceptedValues}
        defaultValue={{ label: value as string, value: value as string }}
      />
    </>
  );
};

export default DropdownField;
